import React, { Component } from 'react';
import Grid from 'screens/components/basic/Grid';
import { scheduleListCrumb } from 'utils/breadcrumbInfo';
import LOOKUP from 'constants/lookup';
import Button from 'screens/components/basic/Button';
import { connect } from "react-redux";
import { getSchedules, createSchedule, getactiveEmployeesOfBranch, updateSchedule, createScheduleRecursive, removeSchedule, removeScheduleRecursive, sendSchedule, getactiveEmployeesFilter, addNewTimeSlot, removeTimeSlot, getCustomTimeSlots } from "actions/EntityActions";
import { clearSchedulesAndEmployees, formInput, saveToForm } from "actions/FormActions";
import { showError } from 'actions/CommonActions';
import { ScheduleStatus } from 'constants/enums';
import moment from "moment";
import ScheduleSendDialog from './scheduleSendDialog';
import DialogInput from 'screens/components/advanced/DialogInput';
import dates from 'react-big-calendar/lib/utils/dates'
import GenericTable from 'screens/components/advanced/GenericTable';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogHeader from 'screens/components/basic/DialogHeader';
import * as types from 'constants/actionTypes';
import ScheduleAddDialog from './scheduleAddDialog';
import ScheduleViewDialog from './scheduleViewDialog';
import ScheduleConfirmDelete from './scheduleConfirmDelete';
import ScheduleConfirmRecursiveDelete from './scheduleConfirmRecursiveDelete';
import ScheduleSetTimeSlotsDialog from './scheduleSetTimeSlotsDialog';
import CalendarSchedule from "./calendarSchedule";

class SchedulePage extends Component {

    constructor(props){
        super(props);

        this.state = {
            openAdd: false,
            openView: false,
            openConfRecurvise : false,
            openConfirm: false,
            openSendSchedule: false,
            openSetTimeSlot: false,
            schedules: [],
            total: 0,
            schedule: {},
            scheduleCreatedId: null,
            scheduleUpdated: false,
            scheduleKeyUpdated: null,
            customTimeSlots: [],
            daysSelected: [],
            openDialog: false,
            currentView: "month",
            currentStartDateMonth: moment().startOf("month"),
            currentEndDateMonth: moment().endOf("month"),
            currentStartDateWeek: moment().startOf("isoweek"),
            currentEndDateWeek: moment().endOf("isoweek")
        };

        this.handleAddDialog = this.handleAddDialog.bind(this);
        this.handleViewDialog = this.handleViewDialog.bind(this);
        this.populateDialog = this.populateDialog.bind(this);
        this.getSchedules = this.getSchedules.bind(this);
        this.createSchedule = this.createSchedule.bind(this);
        this.convertToDateTime = this.convertToDateTime.bind(this);
    }

    componentWillMount(){
        this.getSchedules();
        this.getEmployees();
        this.getCustomTimeSlots();
        this.props.formInput(true, `ScheduleSendByEmail`);
        this.props.formInput(true, `ScheduleSendBySMS`);
    }

    componentWillUnmount(){
        this.props.clearSchedulesAndEmployees();
    }

    componentWillReceiveProps(newProps){

        if(newProps.schedules && newProps.schedules !== this.props.schedules){
            this.setState({ schedules: newProps.schedules.list });
        }

        //Reloading the calendar after adding
        if((newProps.scheduleCreatedId && newProps.scheduleCreatedId !== this.props.scheduleCreatedId) || (newProps.scheduleUpdated != undefined && newProps.scheduleUpdated !== this.props.scheduleUpdated)  || (newProps.scheduleKeyUpdated != undefined && newProps.scheduleKeyUpdated !== this.props.scheduleKeyUpdated)){
            this.getSchedules();
        }

        if (newProps.scheduleRemovedId && newProps.scheduleRemovedId != this.props.scheduleRemovedId) {
            this.setState({...this.state, openConfRecurvise: false, openConfirm: false, openView : false},  () => {
                this.getSchedules();
                this.props.snackbar("Schedule has been deleted.");
            })
        }
        if ((newProps.scheduleSendByEmail && newProps.scheduleSendByEmail != this.props.scheduleSendByEmail) || (newProps.scheduleSendBySMS && newProps.scheduleSendBySMS != this.props.scheduleSendBySMS)) {
            this.getEmployeesFilter(newProps.scheduleSendByEmail, newProps.scheduleSendBySMS);
        }

        if (newProps.scheduleCustomTimeSlots && newProps.scheduleCustomTimeSlots != this.props.scheduleCustomTimeSlots) {
            this.setState({customTimeSlots: newProps.scheduleCustomTimeSlots})
        }

        if (newProps.selectedCustomTimeSlot && newProps.selectedCustomTimeSlot != this.props.selectedCustomTimeSlot) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlot, "");
        }

        if (newProps.selectedCustomTimeSlotView && newProps.selectedCustomTimeSlotView != this.props.selectedCustomTimeSlotView) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotView, "View");
        }

        if (newProps.selectedCustomTimeSlotMonday && newProps.selectedCustomTimeSlotMonday != this.props.selectedCustomTimeSlotMonday) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotMonday, "Monday");
        }

        if (newProps.selectedCustomTimeSlotTuesday && newProps.selectedCustomTimeSlotTuesday != this.props.selectedCustomTimeSlotTuesday) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotTuesday, "Tuesday");
        }

        if (newProps.selectedCustomTimeSlotWednesday && newProps.selectedCustomTimeSlotWednesday != this.props.selectedCustomTimeSlotWednesday) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotWednesday, "Wednesday");
        }

        if (newProps.selectedCustomTimeSlotThursday && newProps.selectedCustomTimeSlotThursday != this.props.selectedCustomTimeSlotThursday) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotThursday, "Thursday");
        }

        if (newProps.selectedCustomTimeSlotFriday && newProps.selectedCustomTimeSlotFriday != this.props.selectedCustomTimeSlotFriday) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotFriday, "Friday");
        }

        if (newProps.selectedCustomTimeSlotSaturday && newProps.selectedCustomTimeSlotSaturday != this.props.selectedCustomTimeSlotSaturday) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotSaturday, "Saturday");
        }

        if (newProps.selectedCustomTimeSlotSunday && newProps.selectedCustomTimeSlotSunday != this.props.selectedCustomTimeSlotSunday) {
            this.formInputTimeSlots(newProps.selectedCustomTimeSlotSunday, "Sunday");
        }

    }

    getSchedules = () => {
        this.props.getSchedules({
            id: null,
            branchId: this.props.branchId,
            startShift: null,
            endShift: null,
            employeeId: null,
            status: ScheduleStatus.Active
        });
    }

    getCustomTimeSlots = () => {
        this.props.getCustomTimeSlots({branchId: this.props.branchId});
    }

    formInputTimeSlots = (selectedCustomTimeSlot, dayOfWeek) => {
        let customTimeSlotsOptions = this.mapCustomTimeSlotOptions(this.state.customTimeSlots);
        let selected = customTimeSlotsOptions.filter(x => x.value === `${selectedCustomTimeSlot}`)[0]; 
        // console.log(customTimeSlotsOptions, selectedCustomTimeSlot, selected)
        if(selected) {
            if (dayOfWeek == "View") {
                this.props.formInput(selected.startShift, `scheduleViewStart`);
                this.props.formInput(selected.endShift, `scheduleViewEnd`);
            } else {
                this.props.formInput(selected.startShift, `ScheduleAdd${dayOfWeek}Start`);
                this.props.formInput(selected.endShift, `ScheduleAdd${dayOfWeek}End`);
            }
        }
    }

    convertToDateTime = (date, time) => {
        let dateInput = new Date(date);
        let timeInput = typeof time === 'string' && time.includes('T') ? time.split('T')[1].split(":") : [0, 0, 0];
        console.log(timeInput);
        
        let day = dateInput.getDate().toString().padStart(2, '0');
        let month = (dateInput.getMonth() + 1).toString().padStart(2, '0');
        let year = dateInput.getFullYear();
        let hour = timeInput[0] ? parseInt(timeInput[0], 10).toString().padStart(2, '0') : '00';
        let minute = timeInput[1] ? parseInt(timeInput[1], 10).toString().padStart(2, '0') : '00';
        let second = timeInput[2] ? parseInt(timeInput[2], 10).toString().padStart(2, '0') : '00';

        return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
    };



    getRecursiveScheduleList = ()=>{
        let list = [];
        if (this.props.monday) {
            if (this.props.mondayStartTime != undefined && this.props.mondayEndTime != undefined) {
                list.push({
                    day: 1,
                    startTime: this.convertToDateTime(0, this.props.mondayStartTime),
                    endTime: this.convertToDateTime(0, this.props.mondayEndTime)
                })
            }
            else{
                return [];
            }
        }
        if (this.props.tuesday) {
            if (this.props.tuesdayStartTime != undefined && this.props.tuesdayEndTime != undefined) {
                list.push({
                    day: 2,
                    startTime: this.convertToDateTime(0, this.props.tuesdayStartTime),
                    endTime: this.convertToDateTime(0, this.props.tuesdayEndTime)
                })
            }else{
                return [];
            }
        }
        if (this.props.wednesday) {
            if (this.props.wednesdayStartTime != undefined && this.props.wednesdayEndTime != undefined) {
                list.push({
                    day: 3,
                    startTime: this.convertToDateTime(0, this.props.wednesdayStartTime),
                    endTime: this.convertToDateTime(0, this.props.wednesdayEndTime)
                })
            }else{
                return [];
            }
        }
        if (this.props.thursday) {
            if (this.props.thursdayStartTime != undefined && this.props.thursdayEndTime != undefined) {
                list.push({
                    day: 4,
                    startTime: this.convertToDateTime(0, this.props.thursdayStartTime),
                    endTime: this.convertToDateTime(0, this.props.thursdayEndTime)
                })
            }else{
                return [];
            }
        }
        if (this.props.friday) {
            if (this.props.fridayStartTime != undefined && this.props.fridayEndTime != undefined) {
                list.push({
                    day: 5,
                    startTime: this.convertToDateTime(0, this.props.fridayStartTime),
                    endTime: this.convertToDateTime(0, this.props.fridayEndTime)
                })
            }
        }
        if (this.props.saturday) {
            if (this.props.saturdayStartTime != undefined && this.props.saturdayEndTime != undefined) {
                list.push({
                    day: 6,
                    startTime: this.convertToDateTime(0, this.props.saturdayStartTime),
                    endTime: this.convertToDateTime(0, this.props.saturdayEndTime)
                })
            }else{
                return [];
            }
        }
        if (this.props.sunday) {
            if (this.props.sundayStartTime != undefined && this.props.sundayEndTime != undefined) {
                list.push({
                    day: 0,
                    startTime: this.convertToDateTime(0, this.props.sundayStartTime),
                    endTime: this.convertToDateTime(0, this.props.sundayEndTime)
                })
            }else{
                return [];
            }
        }

        return list;
    }

    createSchedule = () => {
        let recursiveList= this.getRecursiveScheduleList();
        if (this.props.recursive) {
            if (this.props.employeeId && recursiveList.length !== 0) {
                let model = {
                    id:null,
                    branchId: this.props.branchId,
                    employeeId: parseInt(this.props.employeeId),
                    status: ScheduleStatus.Active,
                    color: this.props.color != undefined ? this.props.color : "#893086",
                    dateStart: this.convertToDateTime(this.props.dateStart, 0),
                    dateEnd: this.convertToDateTime(this.props.dateEnd, 0),
                    recursiveSchedule: recursiveList,
                };
                this.props.createScheduleRecursive(model)
                this.handleAddDialog();
            }else{
                this.setState({...this.state, openDialog: true})
            }
        }else{
            if (this.props.employeeId && this.props.startShift && this.props.endShift) {
                const model = {
                    id: null,
                    branchId: this.props.branchId,
                    startShift: this.convertToDateTime(this.props.date, this.props.startShift),
                    endShift: this.convertToDateTime(this.props.date, this.props.endShift),
                    employeeId: parseInt(this.props.employeeId),
                    status: ScheduleStatus.Active,
                    color: this.props.color != undefined ? this.props.color : "#893086",
                };
                // console.log(model);
                this.props.createSchedule(model);
                this.handleAddDialog();
            }else{
                this.setState({...this.state, openDialog: true})
            }
        }

    }

    getEmployees = () => {
        const model = {
            branchId: this.props.branchId
        }
        this.props.getactiveEmployeesOfBranch(model);
    }

    getEmployeesFilter = (byEmail, bySMS) => {
        const model = {
            branchId: this.props.branchId,
            byEmail: byEmail,
            bySMS: bySMS
        }
        this.props.getactiveEmployeesFilter(model);
    }

    handleAddDialog(e,date = null){
        if(date){
            this.props.saveToForm({
                compName: "ScheduleAdd",
                id : null,
                employee: null,
                date : moment.utc(date).startOf("day").format("LL"),
                dateStart : moment.utc(date).startOf("day").format("LL")
            });
        }else {
            this.props.saveToForm({
                compName: "ScheduleAdd",
                id : null,
                employee: null
            });
        }
        this.setState({openAdd: !this.state.openAdd});
    }

    handleSetTimeSlotsDialog = () => {
        this.setState({openSetTimeSlot: !this.state.openSetTimeSlot});
    }

    handleViewDialog(){
        this.setState({openView: !this.state.openView});
    }


    populateDialog = (event) => {
        //get employee id based on schedule id
        let schedule = this.state.schedules.filter(sc=> sc.id == event.id)[0];
        this.props.saveToForm({
            compName: "scheduleView",
            id : schedule.id,
            start: schedule.startShift,
            end: schedule.endShift,
            date: schedule.date,
            employee: schedule.employeeId.toString(),
            color: schedule.color,
            recursiveId: schedule.recursiveId,
            status: (schedule.status ===  ScheduleStatus.Active)
        });

        this.handleViewDialog()
    }

    updateSchedule = () =>{
        let updatedSchedule = {
            id : this.props.updateId,
            branchId : this.props.branchId,
            startShift : this.convertToDateTime(this.props.updateDate,this.props.updateStartShift),
            endShift : this.convertToDateTime(this.props.updateDate,this.props.updateEndShift),
            employeeId : parseInt(this.props.updateEmployeeId, 10) ,
            status : (this.props.updateStatus ? ScheduleStatus.Active : ScheduleStatus.Inactive ) ,
            color: this.props.updateColor,
            recursiveId: this.props.updateRecursiveId
        };

        this.props.updateSchedule({
            id : updatedSchedule.id,
            branchId : updatedSchedule.branchId,
            startShift : updatedSchedule.startShift,
            endShift : updatedSchedule.endShift,
            employeeId : updatedSchedule.employeeId,
            status : updatedSchedule.status,
            color : updatedSchedule.color,
            recursiveId: this.props.updateRecursiveId
        });
        this.handleViewDialog();

    }

    deleteSchedule = () => {
        if (this.props.updateRecursiveId>0) {
            this.setState({...this.state, openConfRecurvise: true})
        }else{
            this.setState({...this.state, openConfirm: true})
        }
    }

    addNewTimeSlot = () => {
        let startShift = this.props.scheduleSetTimeSlotsStart;
        let endShift = this.props.scheduleSetTimeSlotsEnd;
        let branchId = this.props.branchId;

        if (moment(startShift).isAfter(endShift) && !moment(endShift).isBefore(moment('05:00', 'HH:mm'))){
            this.props.showError("Start time must be before end time");
        } else {
            let model = {
                StartShift: this.convertToDateTime(0, startShift),
                EndShift: this.convertToDateTime(0, endShift),
                BranchId: branchId
            }

            this.props.addNewTimeSlot(model);
        }
    }

    removeTimeSlot = (id) => {
        let model = {
            Id: id,
            BranchId: this.props.branchId
        }
        this.props.removeTimeSlot(model);
    }

    mapCustomTimeSlotOptions = (customTimeSlots) => {
        return (
            customTimeSlots ?
            customTimeSlots.map((item) => {
                return {
                    text: `${moment(item.startShift).format("hh:mm A")} - ${moment(item.endShift).format("hh:mm A")}`,
                    value: item.id.toString(),
                    startShift: item.startShift,
                    endShift: item.endShift
                }
            }) : []
        )
    }

    closeConfirm = () => {
        this.setState({...this.state, openConfirm: false})
    }

    deleteScheduleConfirm = () => {
        this.props.removeSchedule(this.props.updateId);
    }

    closeConfRecursive = () =>{
        this.setState({...this.state, openConfRecurvise: false})
    }

    deleteAllSchedule = () => {
        this.props.removeScheduleRecursive(this.props.updateRecursiveId)
    }

    closeSendSchedule = () =>{
        this.setState({...this.state, openSendSchedule: false})
    }

    openSendSchedule = () => {
        this.setState({...this.state, openSendSchedule: true})
    }

    sendSchedule = (list)=>{
        let model = {
            branchId : this.props.branchId,
            employeesIdList : list,
            byEmail: this.props.scheduleSendByEmail,
            bySMS: this.props.scheduleSendBySMS
        }
        this.props.sendSchedule(model)
        this.closeSendSchedule();
    }

    closeDialog = () =>{
        this.setState({...this.state, openDialog: false})
    }

    onView = (view) => {
        this.setState({currentView: view})
    }

    onNavigate = (date, view) => {
        let currentStartDateWeek = moment(date).startOf("isoweek");
        let currentEndDateWeek = moment(date).endOf("isoweek")
        let currentStartDateMonth = moment(date).startOf("month");
        let currentEndDateMonth = moment(date).endOf("month");

        this.setState({currentStartDateWeek: currentStartDateWeek, currentEndDateWeek: currentEndDateWeek});
        this.setState({currentStartDateMonth: currentStartDateMonth, currentEndDateMonth: currentEndDateMonth});
    }

    mapEmployeeHours = (model = [], currentStartDate, currentEndDate) => {
        let hoursArray = [];
        model.map((item) => {
            if (moment(item.startShift).isBetween(currentStartDate, currentEndDate)){
                let shiftHours = moment(item.endShift).diff(item.startShift, "hours", true);
                shiftHours = Math.round(shiftHours * 10)/10;
                let found = hoursArray.find(x => x.employeeId == item.employeeId);
                if (found) {
                    found.totalHours += shiftHours
                } else {
                    hoursArray.push({
                        employeeId: item.employeeId,
                        employeeName: item.employeeName,
                        totalHours: shiftHours
                        }
                    );
                }
            }}
        )
        return hoursArray.sort((a, b) => {
                if (a.employeeName.toLowerCase() < b.employeeName.toLowerCase())
                    return -1;
                if (a.employeeName.toLowerCase() > b.employeeName.toLowerCase())
                    return 1;
                return 0;
            })
    }

    render(){
        const employeeOptions = (this.props.employeeSend || []).map(item => {
            return {
                text: `${item.firstName} ${item.lastName}`,
                value: item.id.toString()
            };
        });

        let employeeHoursCols = [
            {key: "employeeName", label: "Name"},
            {key: "totalHours", label: "Total Hours"}
        ]

        let customTimeSlotsOptions = this.mapCustomTimeSlotOptions(this.state.customTimeSlots);

        return(
            <Grid headerContent={scheduleListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.admin.items.schedule.text} displayFlex={false}>
                    <Button
                        style={{ width: "220px" }}
                        type="SendButton"
                        mini={true}
                        label={"Send Schedule"}
                        className="bg-light-green mb-2"
                        onTouchTap={this.openSendSchedule}
                    />
                    <br />
                    <Button
                        style={{ width: "220px" }}
                        type="SaveButton"
                        mini={true}
                        label={LOOKUP.menu.admin.items.scheduleTimeSlots.text}
                        className="bg-light-green mb-2"
                        onTouchTap={this.handleSetTimeSlotsDialog}
                    />
                    <br />
                    <Button
                        style={{ width: "220px" }}
                        type="AddButton"
                        mini={true}
                        label={LOOKUP.menu.admin.items.scheduleAdd.text}
                        className="bg-light-green"
                        onTouchTap={this.handleAddDialog}
                    />
                </PageHeaderWithButton>
                    <CalendarSchedule
                        schedules={this.state.schedules}
                        populateDialog={this.populateDialog}
                        handleAddDialog={this.handleAddDialog}
                        onNavigate={this.onNavigate}
                        onView={this.onView}
                    />
                    {this.state.currentView == "week" &&
                        <div className="schedule_table">
                            <h4>{`Weekly Total Hours`}</h4>
                            <GenericTable
                                className="table_centerText tableHeaderTxt"
                                stripedRows={true}
                                columns={employeeHoursCols}
                                rows={this.mapEmployeeHours(this.state.schedules, this.state.currentStartDateWeek, this.state.currentEndDateWeek)}
                            />
                        </div>
                    }
                    {this.state.currentView == "month" &&
                        <div className="schedule_table">
                            <h4>{`Monthly Total Hours`}</h4>
                            <GenericTable
                                className="table_centerText tableHeaderTxt"
                                stripedRows={true}
                                columns={employeeHoursCols}
                                rows={this.mapEmployeeHours(this.state.schedules, this.state.currentStartDateMonth, this.state.currentEndDateMonth)}
                            />
                        </div>
                    }

                <ScheduleAddDialog
                    handleDiag={this.handleAddDialog}
                    open={this.state.openAdd}
                    employeeOptions={employeeOptions}
                    createSchedule={this.createSchedule}
                    recursive = {this.props.recursive}
                    monday= {this.props.monday}
                    tuesday={this.props.tuesday}
                    wednesday = {this.props.wednesday}
                    thursday = {this.props.thursday}
                    friday = {this.props.friday}
                    saturday = {this.props.saturday}
                    sunday = {this.props.sunday}
                    formInput = {this.props.formInput}
                    color= {this.props.color}
                    customTimeSlotsOptions={customTimeSlotsOptions}
                />
                <ScheduleViewDialog
                    employeeOptions={employeeOptions}
                    schedule={this.state.schedule}
                    handleDialog={this.handleViewDialog}
                    open={this.state.openView}
                    updateSchedule = {this.updateSchedule}
                    readonly={false}
                    updateColor = {this.props.updateColor}
                    updateRecursiveId= {this.props.updateRecursiveId}
                    formInput = {this.props.formInput}
                    deleteSchedule= {this.deleteSchedule}
                    updateId={this.props.updateId}
                    customTimeSlotsOptions={customTimeSlotsOptions}

                />
                <ScheduleConfirmRecursiveDelete
                    open={this.state.openConfRecurvise}
                    close={this.closeConfRecursive}
                    deleteSingleSchedule= {this.deleteScheduleConfirm}
                    deleteAllSchedule= {this.deleteAllSchedule}
                />
                <ScheduleConfirmDelete
                    open={this.state.openConfirm}
                    close={this.closeConfirm}
                    deleteSchedule= {this.deleteScheduleConfirm}
                />
                <ScheduleSendDialog
                    sendSchedule={this.sendSchedule}
                    open={this.state.openSendSchedule}
                    close={this.closeSendSchedule}
                    employeeOptions={employeeOptions}
                />
                <ScheduleSetTimeSlotsDialog
                    handleDiag={this.handleSetTimeSlotsDialog}
                    open={this.state.openSetTimeSlot}
                    createSchedule={this.createSchedule}
                    addNewTimeSlot={this.addNewTimeSlot}
                    customTimeSlots={this.state.customTimeSlots}
                    removeTimeSlot={this.removeTimeSlot}
                />
                <DialogInput
                    title={<DialogHeader text="Missing fields" />}
                    modal={true}
                    actions = {[
                        <Button
                            key="CancelButton"
                            type="CancelButton"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            secondary={true}
                            onTouchTap={this.closeDialog}
                        />,
                        <Button
                            key="SaveButton"
                            name="buttonSave"
                            className="pull-right mr-2"
                            label="Ok"
                            onTouchTap={this.closeDialog}
                        />

                    ]}
                    className="schedule_dialog"
                    open={this.state.openDialog}
                >

                    <div className="row m-2">
                        Some fields are missing, please try again.
                    </div>
                </DialogInput>
            </Grid>
        );
    }

}

function mapStatetoProps(state) {
    return {
        schedules: state.entity.schedules,
        branchId: state.common.branchId,
        employees: state.entity.employeeList,
        employeeId: state.form.ScheduleAddEmployee,
        startShift: state.form.ScheduleAddStart,
        endShift: state.form.ScheduleAddEnd,
        date: state.form.ScheduleAddDate,
        updateEmployeeId : state.form.scheduleViewEmployee,
        updateStartShift : state.form.scheduleViewStart,
        updateEndShift : state.form.scheduleViewEnd,
        updateDate : state.form.scheduleViewDate,
        updateId : state.form.scheduleViewId,
        updateStatus : state.form.scheduleViewStatus,
        updateColor : state.form.scheduleViewColor,
        updateRecursiveId : state.form.scheduleViewRecursive,
        recursive: state.form.ScheduleAddRecursive,
        scheduleCreatedId: state.entity.scheduleCreatedId,
        scheduleRemovedId: state.entity.scheduleRemovedId,
        scheduleUpdated: state.entity.scheduleUpdated,
        scheduleKeyUpdated: state.entity.scheduleKeyUpdated,
        dateStart: state.form.ScheduleAddDateStart,
        dateEnd: state.form.ScheduleAddDateEnd,
        selectedCustomTimeSlot: state.form.ScheduleAddSelectedCustomTimeSlot,
        selectedCustomTimeSlotView: state.form.scheduleViewSelectedCustomTimeSlot,
        selectedCustomTimeSlotMonday: state.form.ScheduleAddSelectedCustomTimeSlotMonday,
        selectedCustomTimeSlotTuesday: state.form.ScheduleAddSelectedCustomTimeSlotTuesday,
        selectedCustomTimeSlotWednesday: state.form.ScheduleAddSelectedCustomTimeSlotWednesday,
        selectedCustomTimeSlotThursday: state.form.ScheduleAddSelectedCustomTimeSlotThursday,
        selectedCustomTimeSlotFriday: state.form.ScheduleAddSelectedCustomTimeSlotFriday,
        selectedCustomTimeSlotSaturday: state.form.ScheduleAddSelectedCustomTimeSlotSaturday,
        selectedCustomTimeSlotSunday: state.form.ScheduleAddSelectedCustomTimeSlotSunday,
        monday: state.form["ScheduleAddWeekDay-Monday"],
        mondayStartTime: state.form["ScheduleAddMondayStart"],
        mondayEndTime: state.form["ScheduleAddMondayEnd"],
        tuesday: state.form["ScheduleAddWeekDay-Tuesday"],
        tuesdayStartTime: state.form["ScheduleAddTuesdayStart"],
        tuesdayEndTime: state.form["ScheduleAddTuesdayEnd"],
        wednesday:state.form["ScheduleAddWeekDay-Wednesday"],
        wednesdayStartTime: state.form["ScheduleAddWednesdayStart"],
        wednesdayEndTime: state.form["ScheduleAddWednesdayEnd"],
        thursday:state.form["ScheduleAddWeekDay-Thursday"],
        thursdayStartTime: state.form["ScheduleAddThursdayStart"],
        thursdayEndTime: state.form["ScheduleAddThursdayEnd"],
        friday: state.form["ScheduleAddWeekDay-Friday"],
        fridayStartTime: state.form["ScheduleAddFridayStart"],
        fridayEndTime: state.form["ScheduleAddFridayEnd"],
        saturday: state.form["ScheduleAddWeekDay-Saturday"],
        saturdayStartTime: state.form["ScheduleAddSaturdayStart"],
        saturdayEndTime: state.form["ScheduleAddSaturdayEnd"],
        sunday: state.form["ScheduleAddWeekDay-Sunday"],
        sundayStartTime: state.form["ScheduleAddSundayStart"],
        sundayEndTime: state.form["ScheduleAddSundayEnd"],
        scheduleSendByEmail: state.form["ScheduleSendByEmail"],
        scheduleSendBySMS: state.form["ScheduleSendBySMS"],
        color: state.form.ScheduleAddColor,
        employeeSend: state.entity.employeeSendList,
        scheduleSetTimeSlotsStart: state.form.ScheduleSetTimeSlotsStart,
        scheduleSetTimeSlotsEnd: state.form.ScheduleSetTimeSlotsEnd,
        scheduleCustomTimeSlots: state.entity.scheduleCustomTimeSlots,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        getSchedules: (model) => dispatch(getSchedules(model)),
        createSchedule: (model) => dispatch(createSchedule(model)),
        createScheduleRecursive: (model) => dispatch(createScheduleRecursive(model)),
        removeSchedule: (scheduleId) => dispatch(removeSchedule(scheduleId)),
        removeScheduleRecursive: (scheduleRecursiveId) => dispatch(removeScheduleRecursive(scheduleRecursiveId)),
        updateSchedule:(model) => dispatch(updateSchedule(model)),
        sendSchedule:(model) => dispatch(sendSchedule(model)),
        getactiveEmployeesOfBranch: (model) => dispatch(getactiveEmployeesOfBranch(model)),
        getactiveEmployeesFilter: (model) => dispatch(getactiveEmployeesFilter(model)),
        saveToForm: (model) => dispatch(saveToForm(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        snackbar: (message) => dispatch({ type: types.SNACKBAR_SHOW_MESSAGE, message: message }),
        showError: (message) => dispatch(showError(message)),
        clearSchedulesAndEmployees: () => dispatch(clearSchedulesAndEmployees()),
        addNewTimeSlot: (model) => dispatch(addNewTimeSlot(model)),
        removeTimeSlot: (model) => dispatch(removeTimeSlot(model)),
        getCustomTimeSlots: (branchId) => dispatch(getCustomTimeSlots(branchId))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(SchedulePage);
